module.exports = __webpack_public_path__ + "img/2025-07-21d_1.d7cc8339.jpg";